'use client';

import { useIntl } from 'react-intl';
import { calulatorMessages } from '../../components/CalculatorLayouts/messages';
import { InstallmentPrice } from '../InstallmentPrice/InstallmentPrice.client';
import { InstallmentPriceWithCounter } from '../../components/InstallmentPriceWithCounter/InstallmentPriceWithCounter.client';
import type { InstallmentCalulatorLayoutComponentsDefaultProps } from '../../components/CalculatorLayouts/types';
import { EditableBasePrice } from '../../components/EditableBasePrice/EditableBasePrice.client';
import type { InstallmentData, InstallmentsCalulatorCalculationValuta } from '../../types';

export type InstallmentPriceBoxProps = Pick<
  InstallmentData,
  'currency' | 'singleInstallment' | 'minValue' | 'maxValue'
> &
  Pick<
    InstallmentCalulatorLayoutComponentsDefaultProps,
    'hasEditablePrice' | 'onChangeBasePriceValue'
  > & {
    /**
     * the calculation valuta as float
     */
    calculationValuta: InstallmentsCalulatorCalculationValuta;
    /**
     * triggers loading animation of installment price
     */
    isLoading: boolean;
  };

/**
 * installment price box atom
 *
 * atom to display the base price, the calculated installment price and its headlines
 *
 * */
export const InstallmentPriceBox = ({
  currency,
  calculationValuta,
  singleInstallment,
  minValue,
  maxValue,
  isLoading,
  hasEditablePrice,
  onChangeBasePriceValue,
}: InstallmentPriceBoxProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="bg-color-grey-light flex flex-col items-center p-1.5 pb-2">
      <div className="text-size-body1">{formatMessage(calulatorMessages.basePrice)}</div>
      {hasEditablePrice ? (
        <EditableBasePrice
          calculationValuta={calculationValuta}
          currency={currency}
          onChangeHandler={onChangeBasePriceValue}
          minValue={minValue}
          maxValue={maxValue}
        />
      ) : (
        <InstallmentPrice
          currency={currency}
          installmentValue={calculationValuta}
          variation="CalulationBasis"
        />
      )}
      {singleInstallment && singleInstallment.value && (
        <>
          <div className="text-size-body1 mt-1.5 mb-0.5">
            {formatMessage(calulatorMessages.monthlyInstallment)}
          </div>
          <InstallmentPriceWithCounter
            currency={currency}
            installmentValue={singleInstallment.value}
            isLoading={isLoading}
          />
        </>
      )}
    </div>
  );
};
